import { func } from 'prop-types';

import TrendPropType from 'propTypes/trends';
import getEntityKey from 'helpers/getEntityKey';

export default LineCaps;

/**
 * LineCaps renders a dot at the end of every line that doesn't end with a null
 * value.
 *
 * @param {object} props React props
 * @param {function} props.colorScale A configured ordinal scale, used to get fill color
 * @param {array} props.trends Array of trends to draw linecaps for
 * @param {function} props.x The scale for the horizontal (x) axis
 * @param {function} props.y The scale for the vertical (y) axis
 */
function LineCaps(props) {
  const { trends, colorScale, x, y } = props;

  const findMostRecent = (items) => {
    return items.find((item) => {
      return item.attribute !== 'ud';
    });
  };

  return (
    <>
      <defs>
        <filter
          id="linecap-shadow"
          x="-100%"
          y="-100%"
          width="300%"
          height="300%"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
          <feOffset dx="0" dy="0" result="offsetblur" />
          <feFlood floodColor="#000000" floodOpacity="0.3" />
          <feComposite in2="offsetblur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <g filter="url(#linecap-shadow)">
        {trends.map((trend) => {
          const mostRecentPoint = findMostRecent(trend.data);

          if (mostRecentPoint.value) {
            return (
              <circle
                key={`line-cap-${getEntityKey(trend)}`}
                r="5"
                cx={x(mostRecentPoint.periodKey)}
                cy={y(mostRecentPoint.value)}
                fill={colorScale(trend)}
                stroke="white"
                strokeWidth="2"
              />
            );
          }

          return null;
        })}
      </g>
    </>
  );
}

LineCaps.propTypes = {
  trends: TrendPropType.isRequired,
  colorScale: func.isRequired,
  x: func.isRequired,
  y: func.isRequired,
};
